;
define("cart_rtc_checkout.tpl", function(){});

